// extracted by mini-css-extract-plugin
export default {"cityList":"CityList_cityList__iw1R4"};